<div class="row m-2 pt-2">
  <div class="col-3">
    <button (click)="openDrawer(drawer, EWorkInstructionEditorSidebar.steps)" mat-button>
      <mat-icon class="v-middle">format_list_numbered</mat-icon>
      {{ 'page.workInstructions.steps' | translate }}
    </button>
  </div>
  <div class="col-6 text-center">
    <h1 class="m-0 p-0" mat-dialog-title>{{ selectedStep?.name }}</h1>
  </div>
  <div class="col-3 text-right">
    <button (click)="openDrawer(drawer, EWorkInstructionEditorSidebar.templates)" mat-button>
      <mat-icon class="v-middle material-icons-outlined">dashboard</mat-icon>
      {{ 'page.workInstructions.templates' | translate }}
    </button>
  </div>
</div>
<mat-drawer-container autosize class="h-70-vh">
  <mat-drawer
    #drawer
    mode="side"
    opened="true"
    [position]="drawerType() === EWorkInstructionEditorSidebar.templates ? 'end' : 'start'"
  >
    <app-work-instruction-steps
      [style.display]="drawerType() === EWorkInstructionEditorSidebar.steps ? '' : 'none'"
      [workInstruction]="selectedWorkInstruction()"
      [editedFormOfSelectedItem]="editedForm()"
      (selectedItem)="selectedWorkInstructionStep($event)"
      (stepForms)="getEditedFormOfSteps($event)"
    ></app-work-instruction-steps>
    <app-work-instruction-templates
      [style.display]="drawerType() === EWorkInstructionEditorSidebar.templates ? '' : 'none'"
      (applySelectedTemplate)="applySelectedTemplate($event)"
      [drawerType]="drawerType()"
      [workInstruction]="selectedWorkInstruction()"
    ></app-work-instruction-templates>
  </mat-drawer>
  <div *ngIf="!selectedStep" class="mb-3">
    <mat-icon class="v-middle">eco</mat-icon>
    {{ 'page.workInstructions.noStepInfo' | translate }}
  </div>
  <app-scw-formio-builder
    [disabledForm]="!selectedStep"
    [initialForm]="initialForm"
    (editedForm)="getEditedForm($event)"
  ></app-scw-formio-builder>
</mat-drawer-container>
